export enum RateSideType {
  BID,
  OFFER,
}

export namespace RateSideType {
  let elements = [RateSideType.BID, RateSideType.OFFER];
  let alias = "com.bcdfx.model.RateSideType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
